import React from 'react';
import PropTypes from 'prop-types';
import Tweet from "./Tweet";

const TweetList = props => {
    return (
        props.tweets.map(item => (
            <Tweet data={item} key={`tweet-${item.id}`}/>
        ))
    )
};

TweetList.propTypes = {
    tweets: PropTypes.array.isRequired,
};

export default TweetList;
